module.exports = __webpack_public_path__ + "img/0.354c4301.png";